import isPropValid from "@emotion/is-prop-valid";
import type { PropsWithChildren } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { RouterProvider } from "react-router";
import { StyleSheetManager, ThemeProvider } from "styled-components";

import { SessionProvider } from "context/session/SessionProvider";
import { darkTheme, lightTheme } from "domains/theme/constants/theme";
import { useTheme } from "domains/theme/useTheme";
import { ViewportProvider } from "domains/viewport/components/ViewportProvider";
import { GlobalStyles } from "global-styles";
import { router } from "router/router";
import { store } from "store";

export const App = () => (
  <SessionProvider>
    <ReduxProvider store={store}>
      <StyleSheetManager shouldForwardProp={(prop, target) => (typeof target === "string" ? isPropValid(prop) : true)}>
        <ViewportProvider>
          <ThemeProviderWithState>
            <GlobalStyles />
            <RouterProvider router={router} />
          </ThemeProviderWithState>
        </ViewportProvider>
      </StyleSheetManager>
    </ReduxProvider>
  </SessionProvider>
);

const ThemeProviderWithState = ({ children }: PropsWithChildren) => (
  <ThemeProvider theme={useTheme() === "dark" ? darkTheme : lightTheme}>{children}</ThemeProvider>
);
